'use client';

import { useState } from 'react';
import Image from 'next/image';
import { ChevronDown } from 'lucide-react';
import { AmenityIcon } from '@/components/AmenityIcon';
import siteTheme from '@/lib/theme';
import type { CmsAmenity } from '@/lib/cms';

const { colors, fonts } = siteTheme;

const SHOW_COUNT = 10;

export default function AmenitiesExpand({ amenities }: { amenities: CmsAmenity[] }) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? amenities : amenities.slice(0, SHOW_COUNT);
  const hasMore = amenities.length > SHOW_COUNT;
  return (
    <>
      <div className="v2-amenity-grid">
        {visible.map((a) => (
          <div key={a.id} className="v2-amenity-item">
            {a.image?.url ? (
              <Image src={a.image.url} alt="" aria-hidden width={20} height={20}
                style={{ width: '1.35rem', height: '1.35rem', objectFit: 'contain', flexShrink: 0, opacity: 0.75 }} />
            ) : (
              <span style={{ color: colors.navyDeep, opacity: 0.65, lineHeight: 0, flexShrink: 0 }}>
                <AmenityIcon label={a.label} icon={a.icon} size={18} />
              </span>
            )}
            <span style={{ fontFamily: fonts.sans, fontSize: '1.25rem', fontWeight: 400, color: '#0D2F44' }}>
              {a.label}
            </span>
          </div>
        ))}
      </div>

      {hasMore && (
        <button
          type="button"
          onClick={() => setExpanded(v => !v)}
          style={{
            marginTop: '1.4rem',
            background: 'none', border: 'none', cursor: 'pointer', padding: 0,
            display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
            fontFamily: fonts.sans, fontSize: '1.2rem', fontWeight: 500,
            color: colors.gold, textDecoration: 'underline', textUnderlineOffset: '3px',
          }}
        >
          {expanded ? 'Show less' : `View all ${amenities.length} amenities`}
          <ChevronDown size={12} color={colors.gold} strokeWidth={1.5}
            style={{ transition: 'transform 0.2s', transform: expanded ? 'rotate(180deg)' : 'none' }} />
        </button>
      )}
    </>
  );
}
